import { base } from "thirdweb/chains";
import { createWallet, inAppWallet } from "thirdweb/wallets";
import { WalletProviders } from "../enum/wallet";

export const WALLETS = [
  inAppWallet({
    auth: {
      options: [
        WalletProviders.Google,
        WalletProviders.GitHub,
        WalletProviders.Discord,
        WalletProviders.Telegram,
        WalletProviders.Steam,
        WalletProviders.Twitch,
        WalletProviders.Email,
        WalletProviders.Passkey,
        WalletProviders.X,
        WalletProviders.Coinbase,
        WalletProviders.Line,
        WalletProviders.Apple,
        WalletProviders.Farcaster,
        WalletProviders.Facebook,
        WalletProviders.Guest,
      ],
    },
  }),
  createWallet(WalletProviders.MetaMask),
  createWallet(WalletProviders.CoinbaseWallet, {
    chains: [base],
  }),
  createWallet(WalletProviders.Rainbow),
  createWallet(WalletProviders.Rabby),
  createWallet(WalletProviders.ZerionWallet),
];
